<div class="main_page">
    <div class="main-section success-stories pt-3">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-header mb-4 pb-3  text-center">
                        <h2 class="mb-2">Read Toppers' Success Stories</h2>
                        <p class="f-light mb-0">Out of many 99%lers and Top IIM Converts from iQuanta, few have penned
                            down their success stories to help out their juniors</p>
                    </div>
                </div>
            </div>
    
            <div class="row row-cols-4">
    
                <div class="col" *ngFor="let stories of membersList.slice(0,8)">
                    <div class="success-stories-single-item mb-0 mb-sm-4">
                        <div class="success-stories-header d-flex justify-content-between px-3 py-2">
                            <div>
                                <span class="f-light mb-0">{{stories.title}}</span>
                                <h6 class="f-bold mb-0">{{stories.percent}}</h6>
                            </div>
                            <div class="img">
                                <img class="img-fluid" [src]="stories.img" alt="{{stories.title}}" loading="lazy">
                            </div>
                        </div>
                        <div class="success-stories-content px-3 pt-3 pb-1">
                            <div class="sub_text">
                                <p class="f-light">{{stories.story}}</p>
                            </div>
                            <a class="d-block mt-3" href="{{stories.link}}" target="_blank">Read full story <svg
                                    xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 14 14"
                                    fill="none">
                                    <path d="M1 7H13M13 7L7 1M13 7L7 13" stroke="#E16B3A" stroke-width="1.3"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg></a>
                            <div
                                class="success-stories-footer justify-content-between d-flex align-items-center pt-1 mt-3">
                                <div>
                                    <h3 class="mb-1">{{stories.titlename}}</h3>
                                    <h5 class="f-light mb-0">{{stories.college}}</h5>
                                </div>
    
    
                                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="44" viewBox="0 0 93 44"
                                    fill="none">
                                    <path opacity="0.4"
                                        d="M0 2V39.1111V39.1716C0 40.9534 2.15429 41.8457 3.41422 40.5858L40.5858 3.41421C41.8457 2.15428 40.9534 0 39.1716 0H2C0.895431 0 0 0.895431 0 2Z"
                                        fill="url(#paint0_linear_1349_26)" />
                                    <path opacity="0.4"
                                        d="M49 2V39.1111V39.1716C49 40.9534 51.1543 41.8457 52.4142 40.5858L89.5858 3.41421C90.8457 2.15428 89.9534 0 88.1716 0H51C49.8954 0 49 0.895431 49 2Z"
                                        fill="url(#paint1_linear_1349_26)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_1349_26" x1="22" y1="0" x2="22" y2="44"
                                            gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.11" />
                                            <stop offset="1" stop-color="white" stop-opacity="0.44" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_1349_26" x1="71" y1="0" x2="71" y2="44"
                                            gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.11" />
                                            <stop offset="1" stop-color="white" stop-opacity="0.44" />
                                        </linearGradient>
                                    </defs>
                                </svg>
    
                            </div>
                        </div>
    
                    </div>
                </div>
    
            </div>
        </div>
    </div>
</div>

